const FAQS = [
  {
    q: "Do I need a 3D model of my product?",
    a: "No. Send clear photos with dimensions, or CAD files if you have them. We build the model from your references. Complex or organic shapes may need a custom quote.",
  },
  {
    q: "Will the render match my real product?",
    a: "That is the goal. Marketplaces expect images that accurately show what the buyer receives, so we match your colors, materials and proportions and ask you to approve a preview before final render.",
  },
  {
    q: "Which sizes and formats do you deliver?",
    a: "PNG or JPG stills up to 4K, MP4 and GIF for spins, in square, vertical and wide crops. Tell us your channel and we match its specs.",
  },
  {
    q: "How many revisions are included?",
    a: "Two rounds on most packages and three on the ad campaign set. Changes to the product design itself are quoted separately.",
  },
  {
    q: "How do prices work?",
    a: "Prices shown are launch prices per product and may change. Your quote confirms the final amount before any work starts. Rush delivery adds 25 percent.",
  },
  {
    q: "Do you do real estate or rental 3D tours?",
    a: "Not yet. Choose the property option on the quote form and we will let you know when it opens.",
  },
];

export function Faq() {
  return (
    <section className="t-faq" data-section="faq">
      <header className="t-highlights-head">
        <h2 className="t-section-title">Questions</h2>
      </header>
      <div className="t-faq-list">
        {FAQS.map((f) => (
          <details key={f.q} className="t-faq-item">
            <summary>{f.q}</summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
